import styled from 'styled-components';
import { colors } from '@chegg-ui/theme';
import { Font } from '../../internals/common/styled/common';
var grey200 = colors.grey200;
export var PaymentButtonsWrapper = styled.div.withConfig({
  componentId: "sc-1jqbfb0-0"
})(["flex-direction:row;display:flex;flex-wrap:wrap;justify-content:space-between;"]);
export var Divider = styled.div.withConfig({
  componentId: "sc-1jqbfb0-1"
})(["", ";display:flex;flex-direction:row;text-align:center;margin-bottom:10px;span{margin:0 10px;}&:before,&:after{content:'';flex:1 1;border-bottom:", ";margin:auto;}"], Font, grey200);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/payment-methods/dist/esm/internals/PaymentButtons/styled.js
// module id = 1500
// module chunks = 11